var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-3.5-14a.5.5,0,0,1,.5.5V-12H3v-1.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V-12H5a2,2,0,0,1,2,2V0A2,2,0,0,1,5,2H-5A2,2,0,0,1-7,0V-10a2,2,0,0,1,2-2h1v-1.5A.5.5,0,0,1-3.5-14ZM6-8H2.75v2.25H6ZM6-4.75H2.75v2.5H6Zm0,3.5H2.75V1H5A1,1,0,0,0,6,0Zm-4.25-1v-2.5h-3.5v2.5ZM-1.75,1h3.5V-1.25h-3.5Zm-1-3.25v-2.5H-6v2.5ZM-6-1.25V0A1,1,0,0,0-5,1h2.25V-1.25Zm0-4.5h3.25V-8H-6Zm4.25,0h3.5V-8h-3.5ZM5-11H-5a1,1,0,0,0-1,1v1H6v-1A1,1,0,0,0,5-11Z",
    transform: "translate(7 14)",
    fill: "#0085ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a9a6193ebd1c18ec722084a26fd3899d.svg";
export { ForwardRef as ReactComponent };